import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useDeviceQuery = (deviceId: string) => {
  return useQuery({
    queryKey: ["machine", deviceId],
    queryFn: async () => {
      return adminApiClient.getClock(deviceId);
    },
    staleTime: 0,
    refetchInterval: 5000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
};

export default useDeviceQuery;
